import React from 'react';
import { useQuery } from 'react-query';
import api from '../../services/api';
import { DollarSign } from 'lucide-react';

const Faturamento = () => {
  const { data, isLoading } = useQuery(
    'faturamento',
    async () => {
      const response = await api.get('/api/faturamento/dashboard');
      return response.data.data;
    }
  );

  if (isLoading) {
    return <div className="loading">Carregando...</div>;
  }

  return (
    <div>
      <div className="page-header">
        <h2>Faturamento</h2>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <DollarSign size={24} />
          <div>
            <p className="stat-title">Faturamento do Mês</p>
            <p className="stat-value">R$ {data?.mesAtual?.faturamento?.toFixed(2) || '0.00'}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faturamento;

